module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","no":"No","yes":"Yes"},"no":{"cancel":"Avbryt","no":"Nei","yes":"Ja"}}')
  delete Component.options._Ctor
}
